export default "__VITE_ASSET__0123f83b__"